<template>
    <div class="order">
        <div class="order-inner">
            <Header v-if="!isMobile || isMobile && ![1, '3-digital-confirm', '3-default-confirm'].includes(orderStep)"
                    :title="steps[orderStep] ? steps[orderStep].title : null"
                    :fullscreen="fullscreen"
                    :info="steps[orderStep] ? steps[orderStep].info : null"
                    @close-order="closeOrder"
                    @handle-fullscreen="fullscreen = $event"/>
            <main :class="{'pt-0': ['3-digital-confirm', '3-default-confirm'].includes(orderStep), '-has-feed': isMobile && ['3-digital-more-photos', '3-default-more-photos'].includes(orderStep)}">
                <step-1 v-if="orderStep === 1"/>

                <step-2 v-if="orderStep === 2"/>
                <step-2-view v-if="orderStep === '2-view'"/>

                <step-3-set v-if="orderStep === '3-set'"/>
                <step-3-set-confirm v-if="orderStep === '3-set-confirm'"/>

                <step-3-default v-if="orderStep === '3-default'"/>
                <step-3-default-confirm v-if="orderStep === '3-default-confirm'"/>
                <step-3-default-variants v-if="orderStep === '3-default-variants'"/>
                <step-3-default-bulk-prices v-if="orderStep === '3-default-bulk-prices'"/>
                <step-3-default-more-photos v-if="orderStep === '3-default-more-photos'" :fullscreen="fullscreen"/>

                <step-3-digital v-if="orderStep === '3-digital'"/>
                <step-3-digital-confirm v-if="orderStep === '3-digital-confirm'"/>
                <step-3-digital-variants v-if="orderStep === '3-digital-variants'"/>
                <step-3-digital-bulk-prices v-if="orderStep === '3-digital-bulk-prices'"/>
                <step-3-digital-more-photos v-if="orderStep === '3-digital-more-photos'" :fullscreen="fullscreen"/>

                <step-4 v-if="orderStep === 4"/>
            </main>
            <Footer v-if="!isMobile || isMobile && orderStep !== 1"
                    :fullscreen="fullscreen"
                    @close-order="closeOrder"
                    @handle-fullscreen="fullscreen = $event"/>
            <template v-else>
                <mobile-order-step-1-menu v-if="orderStep === 1"/>
            </template>
        </div>
    </div>
</template>

<script>
  import Header from './order/partials/Header.vue';
  import Footer from './order/partials/Footer.vue';

  import Step1 from './order/Step1.vue';

  import Step2 from './order/Step2.vue';
  import Step2View from './order/Step2View.vue';

  import Step3Set from './order/Step3Set.vue';
  import Step3SetConfirm from './order/Step3SetConfirm.vue';

  import Step3Digital from './order/Step3Digital.vue';
  import Step3DigitalConfirm from './order/Step3DigitalConfirm.vue';
  import Step3DigitalVariants from './order/Step3DigitalVariants.vue';
  import Step3DigitalBulkPrices from './order/Step3DigitalBulkPrices.vue';
  import Step3DigitalMorePhotos from './order/Step3DigitalMorePhotos.vue';

  import Step3Default from './order/Step3Default.vue';
  import Step3DefaultConfirm from './order/Step3DefaultConfirm.vue';
  import Step3DefaultVariants from './order/Step3DefaultVariants.vue';
  import Step3DefaultBulkPrices from './order/Step3DefaultBulkPrices.vue';
  import Step3DefaultMorePhotos from './order/Step3DefaultMorePhotos.vue';

  import Step4 from './order/Step4.vue';

  import MobileOrderStep1Menu from './MobileOrderStep1Menu.vue';

  import order from 'src/mixins/orderComponent';

  export default {
    mixins: [order],
    components: {
      Header,
      Footer,
      Step1,
      Step2,
      Step2View,
      Step3Set,
      Step3SetConfirm,
      Step3Digital,
      Step3DigitalConfirm,
      Step3DigitalVariants,
      Step3DigitalBulkPrices,
      Step3DigitalMorePhotos,
      Step3Default,
      Step3DefaultConfirm,
      Step3DefaultVariants,
      Step3DefaultBulkPrices,
      Step3DefaultMorePhotos,
      Step4,
      MobileOrderStep1Menu,
    },
  };
</script>
